module.exports = __webpack_public_path__ + "img/6.05de8985.png";